<template>
  <v-card class="pa-3">
    <v-card-title>
      Lager Bearbeiten
    </v-card-title>
    <v-divider />
    <v-form v-model="form.valid">
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="form.name" outlined label="Lager Name" :rules="[(v) => !!v || 'Item is required']" />
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="form.serialNumber" outlined label="Lager Seriennummer" />
        </v-col>
        <v-col cols="12">
          <v-text-field v-model="form.number" outlined label="Lager Nummer" :rules="[(v) => !!v || 'Item is required']" />
        </v-col>
      </v-row>
    </v-form>
    <div class="d-flex justify-end">
      <v-btn outlined class="mr-3" @click="close()">
        Abrechen
      </v-btn>
      <v-btn v-model="form.valid" color="primary" @click="update()">
        Speichern
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
   name: 'WarehouseEdit',
   props: {
      warehouse: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            name: this.warehouse.name,
            number: this.warehouse.number,
            serialNumber: this.warehouse.serial_number,
            valid: false,
         }),
      }
   },
   methods: {
      update () {
         this.form.post(this.route('warehouse.update', this.warehouse.id), {
            preserveScoll: true,
            onSuccess: () => {
               this.$emit('updated')
            }
         })
      },
      close () {
         this.$emit('close')
      }
   }
}
</script>

<style>

</style>
